import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_PrimaryActionButton.scss'
import ActionButton from '../ActionButton/ActionButton'
import PropTypes from 'prop-types';

class PrimaryActionButton extends React.Component {
  static propTypes = {
    buttonText: PropTypes.string.isRequired,
    children: PropTypes.node,
    onClick: PropTypes.func,
    preventDefault: PropTypes.bool,
    className: PropTypes.string
  };

  render () {
    const { buttonText, children, className, preventDefault, onClick, ...remainingProps } = this.props

    return <ActionButton
      variant='primary'
      size={'large'}
      buttonText={buttonText}
      {...remainingProps}
      children={children}
      onClick={onClick}
      className={className}
      preventDefault={preventDefault}
      buttonClassName={styles['primary-button']}
      //buttonTextClassName={styles['primary-button-text']}
      //buttonChildrenClassName={styles['primary-button-children']} 
      />
  }
}

export default (PrimaryActionButton)
